<template>
  <div class="box">
    <swiper :options="swiperOptions" v-if="clientWidth > 768" ref="mySwiper" :auto-play="true" class="modulelist6_box swiper-no-swiping exhibition_box" >
      <div v-if="clientWidth > 768" class="swiper-button-prev swiper-button1" slot="button-prev" ></div>
      <div v-if="clientWidth > 768" class="swiper-button-next swiper-button1" slot="button-next" ></div>
      <swiper-slide v-for="(item, index) in list" :key="index" class="modulelist6" >
        <div class="modulelist6_children" v-for="(val, index) in item.children" :key="index" >
          <div class="modulelist6_img">
            <img v-if="val.img" :src="'https://staticdn.ht-s.cn/se/ciif/2023/exhibition/' + val.img" alt="" />
            <img v-else src="https://staticdn.ht-s.cn/se/ciif/2023/exhibition/新品展示所有视频的封面.png" alt="" />
          </div>
          <div class="line6"></div>
          <div class="modulelist6_content">
            <div class="modulelist6_left">
              <span>{{ val.title }}</span>
              <span v-html="val.introduction.split('/n').join('<br />')"></span>
            </div>

            <div class="modulelist6_right" @click="toDetail(val)" v-if="tab">
              <span>查看详情</span>
              <img src="https://staticdn.ht-s.cn/se/ciif/2022/index/icon_next2.png" alt="" />
            </div>
            <div class="modulelist6_right" @click="toDetail(val)" v-else>
              <span>查看详情</span>
              <img src="https://staticdn.ht-s.cn/se/ciif/2022/index/icon_next2.png" alt="" />
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <swiper :options="swiperOption_m" v-else ref="mySwiper" :auto-play="true" class="modulelist6_box exhibition_box" >
      <div v-if="clientWidth < 768" class="swiper-button-prev swiper-button1" slot="button-prev" ></div>
      <div v-if="clientWidth < 768" class="swiper-button-next swiper-button1" slot="button-next" ></div>
      <swiper-slide v-for="item in listm" :key="item.title" class="modulelist6">
        <div class="modulelist6_children" v-for="(val, index) in item.children" :key="index" >
          <div class="modulelist6_img">
            <img v-if="val.img" :src="'https://staticdn.ht-s.cn/se/ciif/2023/exhibition/' + val.img" alt="" />
            <img v-else src="https://staticdn.ht-s.cn/se/ciif/2023/exhibition/新品展示所有视频的封面.png" alt="" />
          </div>
          <div class="line6"></div>
          <div class="modulelist6_content">
            <div class="modulelist6_left">
              <span>{{ val.title }}</span>
              <span v-html="val.introduction.split('/n').join('<br />')"></span>
            </div>
            <div class="modulelist6_right" @click="toDetail(val)" v-if="tab">
              <span>查看详情</span>
              <img src="https://staticdn.ht-s.cn/se/ciif/2022/index/icon_next2.png" alt="" />
            </div>
            <div class="modulelist6_right" @click="toDetail(val)" v-else>
              <span>查看详情</span>
              <img src="https://staticdn.ht-s.cn/se/ciif/2022/index/icon_next2.png" alt="" />
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="intronumber">
      <div class="left"></div>
      <span v-if="clientWidth > 768">{{ currentIndex }}/{{ list.length }}</span>
      <span v-if="clientWidth <= 768">{{ currentIndex_m }}/{{ listm.length }}</span>
      <div class="right"></div>
    </div>
  </div>
</template>

<script>
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  Navigation,
  EffectFade,
} from "swiper/core";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.min.css";
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation, EffectFade]);

export default {
  props: {
    data: {
      type: Object,
      value: {},
    },
    tab: {
      type: Boolean,
      value: false,
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  mounted() {
    this.currentData = this.data.industrial;
  },
  data() {
    const that = this;
    return {
      currentData: [],
      currentIndex: 1,
      currentIndex_m: 1,
      swiperOptions: {
        initialSlide: 0, //第几个开始播放
        slidesPerView: 1, // 一行显示3个
        slidesPerGroup: 1,
        freeMode: true,
        // slidesPerView: 'auto',
        speed: 1000, // 滑动速度
        effect: "flip",
        // loop: true,
        spaceBetween: 30,
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChange: (swiper) => {
            that.currentIndex = swiper.realIndex + 1;
          },
        },
      },
      swiperOption_m: {
        direction: "horizontal",
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // loop: true,
        // slidesPerView: 1.25,
        centeredSlides: true,
        spaceBetween: 40,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChange: (swiper) => {
            that.currentIndex_m = swiper.realIndex + 1;
          },
        },
      },
    };
  },
  methods: {
    toDetail(item) {
      const obj = { event: "trk", ec: "news", ea: "readmore", el: "viewmore" };
      dataLayer.push(JSON.parse(JSON.stringify(obj)));
      let params = this.$route.query;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$store.commit("activeIndex", 3);
      this.$router.push({
        name: "Exhibition",
        query: {
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
          tab: this.tab ? "true" : "false",
          title: item.title,
        },
      });
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    list() {
      let arr = [];
      let i = Math.ceil(this.currentData.length / 6);
      for (let ind = 0; ind < i; ind++) {
        arr.push({
          children: [],
        });
      }
      let index = 0;
      this.currentData.map((sub, subIndex) => {
        arr[index].children.push(sub);
        if (arr[index].children.length >= 6) {
          index += 1;
        }
      });
      let eles;
      if (arr.length === 1 && arr) {
        eles = document.querySelectorAll(".swiper-button1");
        if (eles && eles.length) {
          for (const n of eles) {
            n.style.display = "none";
          }
        }
      } else if (arr.length > 1) {
        eles = document.querySelectorAll(".swiper-button1");
        if (eles && eles.length) {
          for (const n of eles) {
            n.style.display = "flex";
          }
        }
      }
      return arr;
    },
    listm() {
      let arr = [];
      let i = Math.ceil(this.currentData.length / 4);
      for (let ind = 0; ind < i; ind++) {
        arr.push({
          children: [],
        });
      }
      let index = 0;
      this.currentData.map((sub, subIndex) => {
        arr[index].children.push(sub);
        if (arr[index].children.length >= 4) {
          index += 1;
        }
      });
      return arr;
    },
  },
  watch: {
    tab() {
      document.querySelector(".exhibition_box").style.opacity = 0;
      setTimeout(() => {
        document.querySelector(".exhibition_box").style.opacity = 1;
      }, 100);
      if (this.tab) {
        this.currentData = this.data.energy;
      } else {
        this.currentData = this.data.industrial;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>